import { makeStyles } from 'tss-react/mui';

const name = 'StatisticsLayout';

export const useStatisticsLayoutStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',

    gap: theme.spacing(5),
    height: '100%',
  },
}));
